package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.core.model.UINavigationCallbacks
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p10
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p40
import com.example.mystybag.core.ui.theme.LocalTheme.p48
import com.example.mystybag.core.ui.theme.LocalTheme.p64
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.core.views.navBarBottomPadding
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.modifyIf
import com.example.mystybag.common.extensions.noRippleClickable
import com.example.mystybag.common.ui.components.native.SmallButtonWithImage
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p18

@Composable
fun UIAppNavigationBar(
    navigationControls  : UINavigationCallbacks,
    navigationContent   : @Composable (() -> Unit)? = null
) {
    val controls = navigationControls.controls.subscribeAsState()

    if (controls.value.navVisible) {

        val keyboardController  = LocalSoftwareKeyboardController.current

        Column(
            verticalArrangement = Arrangement.Center,
            modifier            = Modifier
                .fillMaxWidth()
                .padding(bottom = navBarBottomPadding.current)
                .then(if (navigationContent == null) Modifier.height(p64) else Modifier)
                //.background(AppTheme.current.navigationCustomColors.topNavigationBarBackground)
        ) {
            navigationContent?.invoke() ?: Box(
                modifier = Modifier.fillMaxWidth()
            ) {
                // Заглавие центрирано в целия екран (първи слой)
                Texts.TitleMedium(
                    modifier = Modifier
                        .align(Alignment.Center)
                        .fillMaxWidth()
                        .padding(horizontal = p48),
                    text      = controls.value.title,
                    textAlign = TextAlign.Center
                )
                // Back бутон и икони като overlay (втори слой)
                Row(
                    modifier            = Modifier
                        .fillMaxWidth()
                        .padding(start = p16, end = p12),
                    verticalAlignment   = Alignment.CenterVertically
                ) {
                    if (controls.value.backButtonVisible) {
                        Box(
                            modifier = Modifier
                                .size(p48)
                                .clip(CircleShape)
                                .background(AppTheme.current.colors.surfaceContainerLowest)
                                .noRippleClickable {
                                    navigationControls.backButtonCallback()
                                    keyboardController?.hide()
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            androidx.compose.foundation.Image(
                                painter = painterResource(SRC.images.arrow_back),
                                contentDescription = null,
                                contentScale = ContentScale.Fit,
                                modifier = Modifier.size(width = p10, height = p18),
                                colorFilter = ColorFilter.tint(AppTheme.current.colors.primary)
                            )
                        }
                    }

                    controls.value.leadingIcon?.let { image ->
                        Box(modifier = Modifier.padding(end = p16)) {
                            ImageDescriptionView(
                                modifier = Modifier
                                    .align(Alignment.CenterStart)
                                    .size(image.size ?: p32)
                                    .clip(CircleShape),
                                image = image
                            )
                        }
                    }

                    Spacer(modifier = Modifier.weight(1f))

                    controls.value.additionalIcons?.forEach { icon ->
                        Box(
                            modifier = Modifier
                                .padding(end = p8)
                                .fillMaxHeight(0.8f)
                                .aspectRatio(1f)
                                .noRippleClickable(icon.action)
                        ) {
                            Image(
                                modifier = Modifier
                                    .size(p40)
                                    .align(Alignment.Center)
                                    .padding(all = p10),
                                painter = painterResource(icon.image)
                            )
                        }
                    }

                    controls.value.smallButtons?.forEachIndexed { index, item ->
                        SmallButtonWithImage(
                            text        = item.buttonText,
                            leadingImage = item.buttonImage,
                            doOnClick   = item.onButtonClick,
                            isSelected  = item.isSelected,
                            modifier    = Modifier
                                .modifyIf(index == (controls.value.smallButtons?.size ?: 0) - 1) { padding(end = p12) }
                                .modifyIf((controls.value.smallButtons?.size ?: 0) > 1) { padding(start = p12) }
                        )
                    }
                }
            }
        }
    }
}

/*@Preview
@Composable
fun UIAppNavigationBarPreview() {
    val controls = object: UINavigationCallbacks {
        override val controls = MutableValue(UINavigationState())
        override fun onSearchButtonClicked(searchIsOpen: Boolean) {}
        override fun onSearchTextChanged(search: String) {}
        override fun onInfoButtonClicked() {}
        override fun backButtonCallback() {}
        override fun onKeyboardAction(imeAction: ImeAction): Boolean { return true }
    }

    AppTheme.setup(true)
    AppThemeView {
        UIAppNavigationBar(navigationControls = controls)
    }
}*/